<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-26 10:07:02
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:57:40
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsStatus.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<rd-status class="fz-12" :text="goodsStatus.text" :statusType="goodsStatus.status"></rd-status>
		<el-tooltip placement="top" :open-delay="300" v-if="row.applyStatusReason || suspendPromotion" :content="row.applyStatusReason || content">
			<div @mouseenter="show" class="cause-desc cursor-pointer fz-12">{{ goodsStatus.descName }} <i class="el-icon-arrow-right"></i></div>
		</el-tooltip>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
import { productCommonLog } from '@/api/secondColonelManage';
export default {
	mixins: [mixin],
	data() {
		return {
			content: '',
		};
	},
	computed: {
		goodsStatus({ row }) {
			let status_obj = {
				text: '',
				status: '',
				descName: '',
			};
			if (+row.auditStatus === 0) {
				status_obj.text = '待审核';
				status_obj.status = 'warning';
			}
			if (+row.auditStatus === 1) {
				status_obj.text = '审核通过';
				status_obj.status = '';
			}
			if (+row.auditStatus === 2) {
				status_obj.text = '审核拒绝';
				status_obj.descName = '拒绝原因';
				status_obj.status = 'error';
			}
			if (+row.applyStatus === 1) {
				status_obj.text = '报名成功';
				status_obj.status = '';

			}
			if (+row.applyStatus === 2) {
				status_obj.text = '报名失败';
				status_obj.descName = '失败原因';
				status_obj.status = 'error';
			}
			if(+row.applyStatus === 1 && +row.promotionStatus === 2){
				status_obj.text = '中止推广';
				status_obj.descName = '中止原因';
				status_obj.status = 'error';
			}

			return status_obj;
		},
		suspendPromotion({row}){
			return +row.applyStatus === 1 && +row.promotionStatus === 2
		}
	},
	methods:{
		async show() {
			if (!this.suspendPromotion) return; 
			const { list = [] } = await productCommonLog({ id: this.row.productCommonId, type: '2' });
			this.content = list[0]?.remark || '';
		},
	}
};
</script>
<style lang="less" scoped>
.cause-desc {
	color: @color-b4;
}
</style>
